import { RankingsView } from "../../../components/RankingsView";

export default function FastCatRankings() {
  return <RankingsView segments={[]} />;
}
